{
  "button_add_more_images": [
    {
      "type": 0,
      "value": "Adicionar mais imagens"
    }
  ],
  "button_approve": [
    {
      "type": 0,
      "value": "Aprovar"
    }
  ],
  "button_back": [
    {
      "type": 0,
      "value": "Voltar"
    }
  ],
  "button_back_to_cart": [
    {
      "type": 0,
      "value": "Gallery"
    }
  ],
  "button_back_to_login": [
    {
      "type": 0,
      "value": "Voltar para o Login"
    }
  ],
  "button_bill_to_room": [
    {
      "type": 0,
      "value": "Cobrar do quarto"
    }
  ],
  "button_buy_more": [
    {
      "type": 0,
      "value": "Comprar mais"
    }
  ],
  "button_cancel": [
    {
      "type": 0,
      "value": "Cancelar"
    }
  ],
  "button_close": [
    {
      "type": 0,
      "value": "Fechar"
    }
  ],
  "button_complete_purchase": [
    {
      "type": 0,
      "value": "Compra concluída"
    }
  ],
  "button_continue": [
    {
      "type": 0,
      "value": "Continuar"
    }
  ],
  "button_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Cartão de crédito ou débito"
    }
  ],
  "button_customer_login": [
    {
      "type": 0,
      "value": "Back to Customer Login"
    }
  ],
  "button_done": [
    {
      "type": 0,
      "value": "FEITO"
    }
  ],
  "button_download": [
    {
      "type": 0,
      "value": "Baixar"
    }
  ],
  "button_edit_order": [
    {
      "type": 0,
      "value": "Editar pedido"
    }
  ],
  "button_enter": [
    {
      "type": 0,
      "value": "Enviar"
    }
  ],
  "button_forgot": [
    {
      "type": 0,
      "value": "Esqueci"
    }
  ],
  "button_got_it": [
    {
      "type": 0,
      "value": "Entendi"
    }
  ],
  "button_image_view_next": [
    {
      "type": 0,
      "value": "Próximo(seta à direita)"
    }
  ],
  "button_image_view_previous": [
    {
      "type": 0,
      "value": "Anterior(seta à esquerda)"
    }
  ],
  "button_image_view_zoom": [
    {
      "type": 0,
      "value": "Aumentar/diminuir o zoom"
    }
  ],
  "button_log_out": [
    {
      "type": 0,
      "value": "Sair"
    }
  ],
  "button_login": [
    {
      "type": 0,
      "value": "Login"
    }
  ],
  "button_lookup_gallery": [
    {
      "type": 0,
      "value": "Galeria de pesquisa"
    }
  ],
  "button_more_images": [
    {
      "type": 0,
      "value": "Mais imagens"
    }
  ],
  "button_new_order": [
    {
      "type": 0,
      "value": "Novo pedido"
    }
  ],
  "button_ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "button_price_guide": [
    {
      "type": 0,
      "value": "Guia de preços"
    }
  ],
  "button_print": [
    {
      "type": 0,
      "value": "Imprimir"
    }
  ],
  "button_process": [
    {
      "type": 0,
      "value": "Processar"
    }
  ],
  "button_purchase": [
    {
      "type": 0,
      "value": "Comprar"
    }
  ],
  "button_refresh": [
    {
      "type": 0,
      "value": "Atualizar"
    }
  ],
  "button_remove": [
    {
      "type": 0,
      "value": "Remover"
    }
  ],
  "button_remove_prints": [
    {
      "type": 0,
      "value": "Remover impressões"
    }
  ],
  "button_review_and_purchase": [
    {
      "type": 0,
      "value": "Revisar e comprar"
    }
  ],
  "button_review_cart": [
    {
      "type": 0,
      "value": "Cart"
    }
  ],
  "button_select": [
    {
      "type": 0,
      "value": "Selecionar"
    }
  ],
  "button_selected_print_sizes": [
    {
      "type": 0,
      "value": "Tamanhos de impressão selecionados ("
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "button_send_link": [
    {
      "type": 0,
      "value": "Enviar link"
    }
  ],
  "button_send_links": [
    {
      "type": 0,
      "value": "Enviar links"
    }
  ],
  "button_share": [
    {
      "type": 0,
      "value": "Compartilhar"
    }
  ],
  "button_stay": [
    {
      "type": 0,
      "value": "Permanecer"
    }
  ],
  "button_stripe_reader": [
    {
      "type": 0,
      "value": "Leitor de tarja"
    }
  ],
  "button_tilby": [
    {
      "type": 0,
      "value": "Tilby"
    }
  ],
  "button_toggle_access_codes": [
    {
      "type": 0,
      "value": "Toggle Access Codes"
    }
  ],
  "button_view_gallery": [
    {
      "type": 0,
      "value": "Ver a galeria"
    }
  ],
  "button_view_my_gallery": [
    {
      "type": 0,
      "value": "Ver minha galeria"
    }
  ],
  "button_view_receipt": [
    {
      "type": 0,
      "value": "Ver o recibo"
    }
  ],
  "cart_add_image_no_cost": [
    {
      "type": 0,
      "value": "Você pode adicionar mais imagens sem custo"
    }
  ],
  "cart_apply_coupon": [
    {
      "type": 0,
      "value": "Aplicar"
    }
  ],
  "cart_buy_all_at_price": [
    {
      "type": 0,
      "value": "O preço para comprar tudo é "
    },
    {
      "type": 1,
      "value": "amount"
    }
  ],
  "cart_buy_all_discount_description": [
    {
      "type": 0,
      "value": "Comprar todas as imagens por "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_buy_all_discount_label": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " por todas"
    }
  ],
  "cart_cart_details": [
    {
      "type": 0,
      "value": "Detalhes do carrinho"
    }
  ],
  "cart_cart_total": [
    {
      "type": 0,
      "value": "Total do carrinho"
    }
  ],
  "cart_checkout": [
    {
      "type": 0,
      "value": "Checkout"
    }
  ],
  "cart_coupon_code": [
    {
      "type": 0,
      "value": "Código promocional"
    }
  ],
  "cart_coupon_code_instructions": [
    {
      "type": 0,
      "value": "Please enter your coupon code to apply it to your order."
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Click continue to proceed to checkout"
    }
  ],
  "cart_credit_debit_card": [
    {
      "type": 0,
      "value": "Cartão de crédito ou débito"
    }
  ],
  "cart_digital_image": [
    {
      "type": 0,
      "value": "Imagens digitais"
    }
  ],
  "cart_digitals": [
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " de imagens digitais"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " imagem digital"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " imagens digitais"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_digitals_and_prints": [
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " de imagens digitais"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " imagem digital"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " imagens digitais"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "digitals"
    },
    {
      "type": 0,
      "value": " e "
    },
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "  de impressões"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " impressão"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " impressões"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_discount_label": [
    {
      "type": 0,
      "value": "Compre mais imagens para obter um desconto"
    }
  ],
  "cart_image_free_of_charge": [
    {
      "type": 0,
      "value": "Esta "
    },
    {
      "type": 1,
      "value": "imageDesc"
    },
    {
      "type": 0,
      "value": " será fornecida gratuitamente."
    }
  ],
  "cart_link_to_gallery": [
    {
      "type": 0,
      "value": "Um link para sua galeria foi enviado para o "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "cart_no_photos_available": [
    {
      "type": 0,
      "value": "No images are currently available. If you just had photos taken, they will be available here soon so check back.  If you have not yet had photos taken, please see a photographer to get started"
    }
  ],
  "cart_no_selected_image": [
    {
      "type": 0,
      "value": "Selecione as imagens para comprar antes do checkout"
    }
  ],
  "cart_on_date": [
    {
      "type": 0,
      "value": "em "
    },
    {
      "type": 1,
      "value": "date"
    }
  ],
  "cart_packages_discount_description": [
    {
      "type": 0,
      "value": "Obtenha "
    },
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " de imagens"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " imagem"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " imagens"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " por "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_all": [
    {
      "type": 0,
      "value": "Obtenha todas as imagens por "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_description_range": [
    {
      "type": 0,
      "value": "Obtenha de "
    },
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": " a "
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " imagens por "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label": [
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " por "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_packages_discount_label_range": [
    {
      "type": 1,
      "value": "minimum"
    },
    {
      "type": 0,
      "value": " a "
    },
    {
      "type": 1,
      "value": "maximum"
    },
    {
      "type": 0,
      "value": " por "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "cart_price_guide": [
    {
      "type": 0,
      "value": "Guia de preços"
    }
  ],
  "cart_price_guide_notes": [
    {
      "type": 0,
      "value": "Consulte o Guia de preços para informações sobre os preços"
    }
  ],
  "cart_prints": [
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": "  de impressões"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " impressão"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " impressões"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    }
  ],
  "cart_purchase": [
    {
      "type": 0,
      "value": "Comprar"
    }
  ],
  "cart_purchase_unavailable": [
    {
      "type": 0,
      "value": "Mobile purchasing is unavailable.  Please visit the on-site kiosk to view"
    }
  ],
  "cart_purchased": [
    {
      "type": 0,
      "value": "Comprado"
    }
  ],
  "cart_purchasing": [
    {
      "type": 0,
      "value": "Compras"
    }
  ],
  "cart_sorry_charge_problem": [
    {
      "type": 0,
      "value": "Lamentamos, mas tivemos um problema que impediu que essa cobrança fosse concluída. Tente novamente e entre em contato conosco se o problema persistir."
    }
  ],
  "cart_standard_price": [
    {
      "type": 0,
      "value": "O preço padrão é "
    },
    {
      "type": 1,
      "value": "amount"
    },
    {
      "type": 0,
      "value": " cada"
    }
  ],
  "cart_thank_you_purchase": [
    {
      "type": 0,
      "value": "Agradecemos pela sua compra!"
    }
  ],
  "cart_total": [
    {
      "type": 0,
      "value": "Total"
    }
  ],
  "cart_unlock_all": [
    {
      "type": 0,
      "value": "Todas as imagens digitais"
    }
  ],
  "cart_unlock_all_prints": [
    {
      "type": 0,
      "value": "Todas as imagens digitais e impressões"
    }
  ],
  "cart_unpurchased": [
    {
      "type": 0,
      "value": "Não comprada"
    }
  ],
  "cart_view_photos": [
    {
      "type": 0,
      "value": "Ver fotos"
    }
  ],
  "cart_volume_discount_description": [
    {
      "type": 0,
      "value": "Compre "
    },
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " de imagens"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " imagem"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " imagens"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " e obtenha o desconto de "
    },
    {
      "type": 1,
      "value": "percent"
    }
  ],
  "cart_volume_discount_label": [
    {
      "type": 1,
      "value": "percent"
    },
    {
      "type": 0,
      "value": " de desconto em "
    },
    {
      "type": 1,
      "value": "quantity"
    },
    {
      "type": 0,
      "value": " ou mais"
    }
  ],
  "consumer_agreement": [
    {
      "type": 0,
      "value": "Ao usar o Capturelife, você concorda com o nosso "
    }
  ],
  "consumer_confirm_password": [
    {
      "type": 0,
      "value": "Insira e confirme sua senha."
    }
  ],
  "consumer_confirm_your_password": [
    {
      "type": 0,
      "value": "Confirmação de senha"
    }
  ],
  "consumer_contact_us": [
    {
      "type": 0,
      "value": "Entre em contato conosco"
    }
  ],
  "consumer_email_or_phone": [
    {
      "type": 0,
      "value": "E-mail ou telefone"
    }
  ],
  "consumer_email_or_phone_long": [
    {
      "type": 0,
      "value": "Endereço de e-mail ou número de telefone"
    }
  ],
  "consumer_email_placeholder": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "consumer_enter_email": [
    {
      "type": 0,
      "value": "Insira um endereço de e-mail."
    }
  ],
  "consumer_enter_password": [
    {
      "type": 0,
      "value": "Insira uma senha."
    }
  ],
  "consumer_enter_valid_email_phone": [
    {
      "type": 0,
      "value": "Insira um endereço de e-mail ou número de telefone válido."
    }
  ],
  "consumer_footer_text": [
    {
      "type": 0,
      "value": "MUNDO BRUXO e todas as marcas registradas, personagens, nomes e índices relacionados são © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)"
    }
  ],
  "consumer_forgot_password": [
    {
      "type": 0,
      "value": "Insira seu endereço de e-mail ou número de telefone para redefinir sua senha"
    }
  ],
  "consumer_forgot_your_password": [
    {
      "type": 0,
      "value": "Esqueceu sua senha?"
    }
  ],
  "consumer_image_view_print_store": [
    {
      "type": 0,
      "value": "Loja de impressão"
    }
  ],
  "consumer_item_generate_qr_code": [
    {
      "type": 0,
      "value": "Gerar Código QR"
    }
  ],
  "consumer_link_expired": [
    {
      "type": 0,
      "value": "Lamentamos, mas este link expirou. Insira seu e-mail ou número de telefone para receber outro link."
    }
  ],
  "consumer_logging_in": [
    {
      "type": 0,
      "value": "Fazendo login..."
    }
  ],
  "consumer_login_message": [
    {
      "type": 0,
      "value": "Vamos voltar a capturar esses momentos!"
    }
  ],
  "consumer_missing_something_error": [
    {
      "type": 0,
      "value": "Opa, parece que está faltando alguma coisa."
    }
  ],
  "consumer_my_personal_data": [
    {
      "type": 0,
      "value": "Meus dados pessoais"
    }
  ],
  "consumer_nav_add_photos": [
    {
      "type": 0,
      "value": "Adicionar fotos"
    }
  ],
  "consumer_nav_add_photos_mobile": [
    {
      "type": 0,
      "value": "Adicionar"
    }
  ],
  "consumer_nav_back": [
    {
      "type": 0,
      "value": "Voltar"
    }
  ],
  "consumer_nav_download": [
    {
      "type": 0,
      "value": "Baixar"
    }
  ],
  "consumer_nav_home": [
    {
      "type": 0,
      "value": "Página inicial"
    }
  ],
  "consumer_nav_logout": [
    {
      "type": 0,
      "value": "Sair"
    }
  ],
  "consumer_nav_news": [
    {
      "type": 0,
      "value": "Novidades"
    }
  ],
  "consumer_nav_print_store": [
    {
      "type": 0,
      "value": "Loja de impressão"
    }
  ],
  "consumer_nav_profile": [
    {
      "type": 0,
      "value": "Perfil"
    }
  ],
  "consumer_nav_refresh": [
    {
      "type": 0,
      "value": "Atualizar"
    }
  ],
  "consumer_nav_share": [
    {
      "type": 0,
      "value": "Compartilhar"
    }
  ],
  "consumer_password_alteast_length": [
    {
      "type": 0,
      "value": "Sua senha deve ter, pelo menos, "
    },
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " caracteres."
    }
  ],
  "consumer_password_placeholder": [
    {
      "type": 0,
      "value": "Senha"
    }
  ],
  "consumer_passwords_dont_match": [
    {
      "type": 0,
      "value": "Sua senha e confirmação de senha não correspondem."
    }
  ],
  "consumer_qr_text": [
    {
      "type": 0,
      "value": "Faça uma captura de tela do seu Código QR ou clique no botão Baixar abaixo"
    }
  ],
  "consumer_reset_password": [
    {
      "type": 0,
      "value": "Redefinir a senha"
    }
  ],
  "consumer_resetting_password": [
    {
      "type": 0,
      "value": "Redefinindo a senha..."
    }
  ],
  "consumer_retake_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_search_photo_button": [
    {
      "type": 0,
      "value": "Search for photos"
    }
  ],
  "consumer_select_all": [
    {
      "type": 0,
      "value": "Selecionar tudo"
    }
  ],
  "consumer_selfie_button": [
    {
      "type": 0,
      "value": "Choose a selfie"
    }
  ],
  "consumer_selfie_instructions": [
    {
      "type": 0,
      "value": "Upload a selfie to get started"
    }
  ],
  "consumer_selfie_upload_complete": [
    {
      "type": 0,
      "value": "Selfie successfully uploaded"
    }
  ],
  "consumer_selfie_upload_failed": [
    {
      "type": 0,
      "value": "An error occurred.  Please try again"
    }
  ],
  "consumer_selfie_upload_in_progress": [
    {
      "type": 0,
      "value": "Upload in progress"
    }
  ],
  "consumer_share_dialog_notes": [
    {
      "type": 0,
      "value": "Para baixar ou compartilhar uma imagem, efetue um toque longo na imagem para abrir as opções de compartilhamento do dispositivo."
    }
  ],
  "consumer_store_title": [
    {
      "type": 0,
      "value": "Loja on-line"
    }
  ],
  "consumer_take_photo_button": [
    {
      "type": 0,
      "value": "Take a Photo"
    }
  ],
  "consumer_terms_of_use": [
    {
      "type": 0,
      "value": "Termos de uso"
    }
  ],
  "consumer_update_email": [
    {
      "type": 0,
      "value": "Insira o e-mail e a senha que você gostaria de usar."
    }
  ],
  "consumer_update_password": [
    {
      "type": 0,
      "value": "Atualizar senha"
    }
  ],
  "consumer_update_your_password": [
    {
      "type": 0,
      "value": "Atualizar sua senha"
    }
  ],
  "consumer_updating_password": [
    {
      "type": 0,
      "value": "Atualizando a senha..."
    }
  ],
  "consumer_welcome_back": [
    {
      "type": 0,
      "value": "Bem-vindo de volta!"
    }
  ],
  "error_coupon_minimum": [
    {
      "type": 0,
      "value": "Não é possível aplicar o código de desconto. O total da compra está abaixo do valor mínimo exigido"
    }
  ],
  "error_coupon_not_found": [
    {
      "type": 0,
      "value": "Código de desconto não encontrado"
    }
  ],
  "error_email_invalid": [
    {
      "type": 0,
      "value": "Insira um endereço de e-mail real."
    }
  ],
  "error_email_required": [
    {
      "type": 0,
      "value": "Insira seu endereço de e-mail."
    }
  ],
  "error_fields_required": [
    {
      "type": 0,
      "value": "Preencha os campos abaixo."
    }
  ],
  "error_reservation_not_found": [
    {
      "type": 0,
      "value": "Reserva não encontrada."
    }
  ],
  "error_scan_band": [
    {
      "type": 0,
      "value": "Não há fotos para esta conta. Escaneie uma pulseira que foi usada na estação de fotos"
    }
  ],
  "error_see_attendant": [
    {
      "type": 0,
      "value": "Não há fotos para esta conta. Consulte um fotógrafo ou atendente"
    }
  ],
  "form_label_credit_or_debit_card": [
    {
      "type": 0,
      "value": "Cartão de crédito ou débito"
    }
  ],
  "form_label_customers_name": [
    {
      "type": 0,
      "value": "Customer's Name"
    }
  ],
  "form_label_email": [
    {
      "type": 0,
      "value": "E-mail"
    }
  ],
  "form_label_email_address": [
    {
      "type": 0,
      "value": "Endereço de e-mail"
    }
  ],
  "form_label_last_name": [
    {
      "type": 0,
      "value": "Sobrenome"
    }
  ],
  "form_label_password": [
    {
      "type": 0,
      "value": "Senha"
    }
  ],
  "form_label_pin": [
    {
      "type": 0,
      "value": "Pin"
    }
  ],
  "form_label_price": [
    {
      "type": 0,
      "value": "Preço (em "
    },
    {
      "type": 1,
      "value": "currency"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "form_label_room_number": [
    {
      "type": 0,
      "value": "Número do quarto"
    }
  ],
  "form_label_secret_code": [
    {
      "type": 0,
      "value": "Código secreto"
    }
  ],
  "form_label_select_all": [
    {
      "type": 0,
      "value": "Selecionar tudo"
    }
  ],
  "form_label_unlock_all": [
    {
      "type": 0,
      "value": "Desbloquear todas as imagens"
    }
  ],
  "kiosk_approval_form_header": [
    {
      "type": 0,
      "value": "Aprovação necessária"
    }
  ],
  "kiosk_approval_form_instructions": [
    {
      "type": 0,
      "value": "Solicite assistência"
    }
  ],
  "kiosk_attendant_form_header": [
    {
      "type": 0,
      "value": "Aprovar a compra"
    }
  ],
  "kiosk_attendant_form_instructions": [
    {
      "type": 0,
      "value": "Insira o preço para esta compra."
    }
  ],
  "kiosk_auto_logout_subtitle": [
    {
      "type": 0,
      "value": "Você será automaticamente desconectado em "
    },
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " de segundos"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " segundo"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " segundos"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "kiosk_auto_logout_title": [
    {
      "type": 0,
      "value": "Olá, ainda está aí?"
    }
  ],
  "kiosk_cart_count_verbose": [
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " de imagens digitais"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " imagem digital"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " imagens digitais"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "imageCount"
    },
    {
      "type": 0,
      "value": ", "
    },
    {
      "offset": 0,
      "options": {
        "many": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " de impressões"
            }
          ]
        },
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " impressão"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " impressões"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "printCount"
    }
  ],
  "kiosk_cart_header": [
    {
      "type": 0,
      "value": "Revisar e comprar"
    }
  ],
  "kiosk_cart_instructions": [
    {
      "type": 0,
      "value": "Toque em "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " para remover uma imagem do seu carrinho. Toque em "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "CONCLUIR COMPRA"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " para continuar."
    }
  ],
  "kiosk_catalog_header": [
    {
      "type": 0,
      "value": "Adicionar imagens à sua galeria"
    }
  ],
  "kiosk_catalog_header_no_gallery": [
    {
      "type": 0,
      "value": "Selecionar imagens para comprar"
    }
  ],
  "kiosk_catalog_instructions": [
    {
      "type": 0,
      "value": "Toque nas imagens para adicioná-las à sua galeria. Toque em "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "VER MINHA GALERIA"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " para voltar à sua galeria."
    }
  ],
  "kiosk_catalog_instructions_no_gallery": [
    {
      "type": 0,
      "value": "Toque nas imagens para adicioná-las ao seu pedido. Toque em "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "REVISAR E COMPRAR"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " para continuar."
    }
  ],
  "kiosk_catalog_loading_message": [
    {
      "type": 0,
      "value": "Carregando imagens..."
    }
  ],
  "kiosk_edit_moment_adjust_subject": [
    {
      "type": 0,
      "value": "Adjust Subject"
    }
  ],
  "kiosk_edit_moment_apply_changes": [
    {
      "type": 0,
      "value": "Apply Changes"
    }
  ],
  "kiosk_edit_moment_apply_overlay": [
    {
      "type": 0,
      "value": "Apply Overlay"
    }
  ],
  "kiosk_edit_moment_back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "kiosk_edit_moment_close_confirmation": [
    {
      "type": 0,
      "value": "All changes you have made will be discarded. Are you sure you want to continue?"
    }
  ],
  "kiosk_edit_moment_complete_edit": [
    {
      "type": 0,
      "value": "Complete Edit"
    }
  ],
  "kiosk_edit_moment_crop_image": [
    {
      "type": 0,
      "value": "Crop Image"
    }
  ],
  "kiosk_edit_moment_done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "kiosk_edit_moment_next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "kiosk_gallery_header": [
    {
      "type": 0,
      "value": "Selecionar e comprar"
    }
  ],
  "kiosk_gallery_header_clubmed": [
    {
      "type": 0,
      "value": "Sua galeria de imagens"
    }
  ],
  "kiosk_gallery_header_pre_print": [
    {
      "type": 0,
      "value": "Selecionar e imprimir"
    }
  ],
  "kiosk_gallery_header_unlocked": [
    {
      "type": 0,
      "value": "Sua galeria de imagens"
    }
  ],
  "kiosk_gallery_instructions": [
    {
      "type": 0,
      "value": "Toque na imagem para selecionar para a compra. Toque em "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " para continuar."
    }
  ],
  "kiosk_gallery_instructions_empty_gallery": [
    {
      "type": 0,
      "value": "Sua galeria está vazia. Toque em "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "MAIS IMAGENS"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " no canto superior direito da tela para navegar pelas imagens disponíveis."
    }
  ],
  "kiosk_gallery_instructions_pre_print": [
    {
      "type": 0,
      "value": "Toque no ícone de impressão em uma imagem para selecioná-la para impressão. Toque no botão Imprimir para baixar as imagens selecionadas"
    }
  ],
  "kiosk_gallery_instructions_prints": [
    {
      "type": 0,
      "value": "Toque na imagem para selecionar para a compra. Toque duas vezes para solicitar uma impressão. Toque em "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "buttonLabel"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " para continuar."
    }
  ],
  "kiosk_gallery_instructions_unlocked": [
    {
      "type": 0,
      "value": "Você desbloqueou todas as imagens. Toque em "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " para remover da sua galeria."
    }
  ],
  "kiosk_gallery_instructions_unlocked_prints": [
    {
      "type": 0,
      "value": "Você desbloqueou todas as imagens. Toque em uma imagem para solicitar uma impressão. Toque em "
    },
    {
      "children": [
      ],
      "type": 8,
      "value": "CloseIcon"
    },
    {
      "type": 0,
      "value": " para remover da sua galeria."
    }
  ],
  "kiosk_image_tooltip_add_print": [
    {
      "type": 0,
      "value": "Adicionar impressão"
    }
  ],
  "kiosk_image_tooltip_digital_purchased": [
    {
      "type": 0,
      "value": "Digital comprada"
    }
  ],
  "kiosk_image_tooltip_print_purchased": [
    {
      "type": 0,
      "value": "Impressão comprada"
    }
  ],
  "kiosk_image_tooltip_print_selected": [
    {
      "type": 0,
      "value": "Impressão selecionada"
    }
  ],
  "kiosk_image_tooltip_remove_print": [
    {
      "type": 0,
      "value": "Remover impressão"
    }
  ],
  "kiosk_image_tooltip_select_print": [
    {
      "type": 0,
      "value": "Selecionar impressão"
    }
  ],
  "kiosk_images_header": [
    {
      "type": 0,
      "value": "Suas imagens"
    }
  ],
  "kiosk_images_header_clubmed": [
    {
      "type": 0,
      "value": "Selecionar imagens"
    }
  ],
  "kiosk_images_header_selected": [
    {
      "type": 0,
      "value": "Sua seleção"
    }
  ],
  "kiosk_login_header_access_your_images": [
    {
      "type": 0,
      "value": "Acessar suas imagens"
    }
  ],
  "kiosk_login_header_clubmed": [
    {
      "type": 0,
      "value": "Insira o número do quarto, sobrenome e e-mail para acessar sua galeria"
    }
  ],
  "kiosk_login_header_preprint": [
    {
      "type": 0,
      "value": "Pre-Print Gallery"
    }
  ],
  "kiosk_login_header_welcome": [
    {
      "type": 0,
      "value": "Bem-vindo!"
    }
  ],
  "kiosk_login_hpx_footer_text": [
    {
      "type": 0,
      "value": "MUNDO BRUXO e todas as marcas registradas, personagens, nomes e índices relacionados são © & ™ Warner Bros. Entertainment Inc. Publishing Rights © JKR. (s22)"
    }
  ],
  "kiosk_login_instructions_enter_email": [
    {
      "type": 0,
      "value": "Insira seu endereço de e-mail para continuar."
    }
  ],
  "kiosk_login_instructions_scan_band": [
    {
      "type": 0,
      "value": "Escaneie sua pulseira para começar"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_header": [
    {
      "type": 0,
      "value": "Cobrar do quarto"
    }
  ],
  "kiosk_offsite_pos_form_bill_to_room_instructions": [
    {
      "type": 0,
      "value": "O total abaixo será cobrado em seu quarto"
    }
  ],
  "kiosk_offsite_pos_form_generic_header": [
    {
      "type": 0,
      "value": "Compra concluída"
    }
  ],
  "kiosk_offsite_pos_form_generic_instructions": [
    {
      "type": 0,
      "value": "Seu pedido inclui:"
    }
  ],
  "kiosk_order_details_disclaimer_no_refunds": [
    {
      "type": 0,
      "value": "* Todas as vendas são definitivas e os reembolsos não podem ser fornecidos."
    }
  ],
  "kiosk_order_details_header": [
    {
      "type": 0,
      "value": "Detalhes do pedido"
    }
  ],
  "kiosk_order_details_instructions": [
    {
      "type": 0,
      "value": "Toque nas imagens à esquerda para selecionar para a compra."
    }
  ],
  "kiosk_order_details_instructions_cart_empty": [
    {
      "type": 0,
      "value": "Seu carrinho está vazio. Toque nas imagens para adicioná-las ao seu pedido."
    }
  ],
  "kiosk_order_details_instructions_cart_empty_more_images": [
    {
      "type": 0,
      "value": "Seu carrinho está vazio. Toque em "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "ADICIONAR MAIS IMAGENS"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " para adicionar mais imagens"
    }
  ],
  "kiosk_order_details_instructions_email": [
    {
      "type": 0,
      "value": "Você receberá suas imagens por e-mail"
    }
  ],
  "kiosk_order_details_instructions_prints": [
    {
      "type": 0,
      "value": "Toque duas vezes na imagem para solicitar uma impressão."
    }
  ],
  "kiosk_payment_method_form_header": [
    {
      "type": 0,
      "value": "Compra concluída"
    }
  ],
  "kiosk_payment_method_form_instructions": [
    {
      "type": 0,
      "value": "Como você gostaria de concluir sua compra?"
    }
  ],
  "kiosk_price_guide_header": [
    {
      "type": 0,
      "value": "Guia de preços"
    }
  ],
  "kiosk_price_guide_instructions": [
    {
      "type": 0,
      "value": "Compre mais imagens para obter um desconto"
    }
  ],
  "kiosk_price_guide_instructions_standard_price": [
    {
      "type": 0,
      "value": "O preço padrão é "
    },
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " por imagem"
    }
  ],
  "kiosk_price_guide_instructions_unlocked": [
    {
      "type": 0,
      "value": "Você pode adicionar mais imagens sem custo"
    }
  ],
  "kiosk_print_size_edits_cancel": [
    {
      "type": 0,
      "value": "Cancel"
    }
  ],
  "kiosk_print_size_edits_continue": [
    {
      "type": 0,
      "value": "Continue"
    }
  ],
  "kiosk_print_size_edits_create": [
    {
      "type": 0,
      "value": "Create"
    }
  ],
  "kiosk_print_size_select_header": [
    {
      "type": 0,
      "value": "Tamanhos de impressão"
    }
  ],
  "kiosk_print_size_select_instructions": [
    {
      "type": 0,
      "value": "Selecionar tamanho(s) e contagem de impressão"
    }
  ],
  "kiosk_processing_edited_moment": [
    {
      "type": 0,
      "value": "Processing edited moment..."
    }
  ],
  "kiosk_processing_payment": [
    {
      "type": 0,
      "value": "Processando o pagamento..."
    }
  ],
  "kiosk_purchase_details_discounts_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Descontos oferecidos:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_packages_offered": [
    {
      "children": [
        {
          "type": 0,
          "value": "Pacotes oferecidos:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_per_image": [
    {
      "type": 1,
      "value": "price"
    },
    {
      "type": 0,
      "value": " por imagem"
    }
  ],
  "kiosk_purchase_details_standard_price": [
    {
      "children": [
        {
          "type": 0,
          "value": "Preço padrão:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_details_total": [
    {
      "children": [
        {
          "type": 0,
          "value": "Total:"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "kiosk_purchase_disabled_instructions": [
    {
      "type": 0,
      "value": "Toque nas imagens para adicioná-las ao seu pedido"
    }
  ],
  "kiosk_purchase_disabled_instructions_more_images": [
    {
      "type": 0,
      "value": "Toque nas imagens para selecioná-las ou desmarcá-las para a compra. Para adicionar mais imagens da sua seleção, toque em "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "MAIS IMAGENS"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_reader_not_connected": [
    {
      "type": 0,
      "value": "Leitor não conectado"
    }
  ],
  "kiosk_reader_payment_failed": [
    {
      "type": 0,
      "value": "O leitor falhou ao processar"
    }
  ],
  "kiosk_reader_standby": [
    {
      "type": 0,
      "value": "Leitor em modo de espera..."
    }
  ],
  "kiosk_receipt_header": [
    {
      "type": 0,
      "value": "Compra concluída"
    }
  ],
  "kiosk_receipt_instructions": [
    {
      "type": 0,
      "value": "Um link para sua galeria foi enviado para o "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_remove_modal_instructions": [
    {
      "type": 0,
      "value": "Você deseja remover esta imagem do seu pedido? Você precisará encontrá-la novamente tocando em "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "ADICIONAR MAIS IMAGENS"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_room_dialog_header": [
    {
      "type": 0,
      "value": "Quarto "
    },
    {
      "type": 1,
      "value": "room"
    }
  ],
  "kiosk_room_dialog_header_multiple": [
    {
      "type": 0,
      "value": "Quartos "
    },
    {
      "type": 1,
      "value": "rooms"
    }
  ],
  "kiosk_room_dialog_instructions_link_sent": [
    {
      "type": 0,
      "value": "Um link foi enviado por e-mail para "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "kiosk_selected_print_size": [
    {
      "type": 0,
      "value": "Print Size"
    }
  ],
  "kiosk_selected_print_sizes_aspect_column": [
    {
      "type": 0,
      "value": "Proporção da imagem"
    }
  ],
  "kiosk_selected_print_sizes_header": [
    {
      "type": 0,
      "value": "Impressões selecionadas"
    }
  ],
  "kiosk_selected_print_sizes_photo_column": [
    {
      "type": 0,
      "value": "Momento"
    }
  ],
  "kiosk_selected_print_sizes_quantity_column": [
    {
      "type": 0,
      "value": "Contagem"
    }
  ],
  "kiosk_selected_print_sizes_size_column": [
    {
      "type": 0,
      "value": "Tamanho de impressão"
    }
  ],
  "kiosk_stripe_form_header": [
    {
      "type": 0,
      "value": "Compra concluída"
    }
  ],
  "kiosk_stripe_form_header_clubmed": [
    {
      "type": 0,
      "value": "Inserir informações de pagamento"
    }
  ],
  "kiosk_topbar_welcome_message": [
    {
      "type": 0,
      "value": "Boas-vindas, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "kiosk_welcome_message": [
    {
      "type": 0,
      "value": "Boas-vindas, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "!"
    }
  ]
}